/**
 * Получение номеров телефона
 */
export const getPhoneInformation = () => ({
    url: '/information',
    method: 'GET',
});
